import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { HttpService } from '../service/http.service';
import { MyBooking } from '../my-booking';
import * as moment from 'moment';
import { ToastMessageService } from '../toast-message.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ApiError } from '../api-error';
import { Table } from 'primeng/table';
import { FilterService } from 'primeng/api';
import Decimal from 'decimal.js';

@Component({
  selector: 'app-my-bookings',
  templateUrl: './my-bookings.component.html',
  styleUrls: ['./my-bookings.component.css']
})
export class MyBookingsComponent implements OnInit {

  bookings: MyBooking[] = [];
  dataLength!: number;
  isLoading = false;
  @ViewChild('dataTable') table!: Table;
  @ViewChild("idInput") idInput!: ElementRef;
  @ViewChild("firstNameInput") firstNameInput!: ElementRef;
  @ViewChild("lastNameInput") lastNameInput!: ElementRef;
  @ViewChild("schoolNameInput") schoolNameInput!: ElementRef;
  @ViewChild("languageCourseInput") languageCourseInput!: ElementRef;
  @ViewChild("studentLanguageInput") studentLanguageInput!: ElementRef;
  @ViewChild("durationInput") durationInput!: ElementRef;
  @ViewChild("paidInput") paidInput!: ElementRef;
  @ViewChild("balanceInput") balanceInput!: ElementRef;

  constructor(
    private httpService: HttpService,
    private toastService: ToastMessageService,
    private filterService: FilterService
  ) { }

  ngOnInit(): void {
    this.getAllBookings();
    this.initFilter();
  }

  initFilter(){
    this.filterService.register("amount", (value: any, filter: any): boolean => {
      if(filter === undefined || filter === null || filter.trim() === ""){
        return true;
      }
      if(value === undefined || value === null){
        return false;
      }
      if(isNaN(value) || isNaN(filter)){
        return false;
      }
      return new Decimal(filter).equals(value);
    });
  }

  filterTable(event: any) {
    this.dataLength = event.filteredValue.length;
  }

  clearFilters() {
    if(this.idInput){
      this.idInput.nativeElement.value = "";
    }
    if(this.firstNameInput){
      this.firstNameInput.nativeElement.value = "";
    }
    if(this.lastNameInput){
      this.lastNameInput.nativeElement.value = "";
    }
    if(this.schoolNameInput){
      this.schoolNameInput.nativeElement.value = "";
    }
    if(this.studentLanguageInput){
      this.studentLanguageInput.nativeElement.value = "";
    }
    if(this.durationInput){
      this.durationInput.nativeElement.value = "";
    }
    if(this.languageCourseInput){
      this.languageCourseInput.nativeElement.value = "";
    }
    if(this.paidInput){
      this.paidInput.nativeElement.value = ""; 
    }
    if(this.balanceInput){
      this.balanceInput.nativeElement.value = ""; 
    }
    this.table.reset();
  }

  sortById(){
    this.bookings.sort((booking1, booking2) => {
      return booking1.id < booking2.id?1:-1;
    });
  }

  getFutureStarting() {
    this.isLoading = true;
    this.httpService.getMyBookings().subscribe(res => {
      for (let booking of res) {
        booking.startDate = moment(booking.startDate).toDate();
        booking.endDate = moment(booking.endDate).toDate();
      }
      let newBookings = res.filter(booking => {
        return moment().isBefore(moment(booking.startDate));
      }).sort((booking1, booking2) => {
        return moment(booking1.startDate).isAfter(moment(booking2.startDate))?1:-1;
      });
      this.bookings = newBookings;
      this.dataLength = this.bookings.length;
      this.isLoading = false;
      this.clearFilters();
    }, error => {
      this.showError(error);
      this.isLoading = false;
    });
  }

  getAllBookings() {
    this.isLoading = true;
    this.httpService.getMyBookings().subscribe(res => {
      this.dataLength = res.length;
      this.bookings = res;
      for (let booking of this.bookings) {
        booking.startDate = moment(booking.startDate).toDate();
        booking.endDate = moment(booking.endDate).toDate();
      }
      this.isLoading = false;
      this.clearFilters();
    }, error => {
      this.showError(error);
      this.isLoading = false;
    });
  }

  getCurrentBookings(){
    this.isLoading = true;
    this.httpService.getMyBookings().subscribe(res => {
      for (let booking of res) {
        booking.startDate = moment(booking.startDate).toDate();
        booking.endDate = moment(booking.endDate).toDate();
      }
      let newBookings = res.filter(booking => {
        const now = moment();
        return moment(booking.startDate).isBefore(now) && now.isBefore(moment(booking.endDate));
      }).sort((booking1, booking2) => {
        return moment(booking1.startDate).isAfter(moment(booking2.startDate))?1:-1;
      });
      this.bookings = newBookings;
      this.dataLength = this.bookings.length;
      this.isLoading = false;
      this.clearFilters();
    }, error => {
      this.showError(error);
      this.isLoading = false
    });
  }

  showError(error: HttpErrorResponse){
    const apiError = new ApiError(error);
    this.toastService.addError("Error", apiError.message);
  }

}
